/** @ngInject */
import {ReactTableController} from "./reactTableController";

export class ReactEditionTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies, detailView, tableService, restUrl, title, tableParamsKey,
                rowNodeID, selectedRowsActions, defaultSortModel) {
        super($scope, userService, arsMainDependencies, detailView, tableService, restUrl, title, tableParamsKey,
            rowNodeID, selectedRowsActions, [], defaultSortModel);
        // Account Group creation/update
        $scope.$on('loadSelection', () => {
            $scope.parentController.isAllSelected = this.isAllSelected;
            if(this.isAllSelected) {
                this.constructFilterFromReactTable();
                $scope.parentController.element.filter = this.backendService.service.config.params.filter;
            } else{
                $scope.parentController.selectedItems = this.getSelectedRowIDs();
            }
        });
        this.defaultReactGridParams.gridOptions.onFirstDataRendered = (event) => this.initSelection(event.api);
        this.defaultReactGridParams.gridOptions.onModelUpdated = (event) => this.initSelection(event.api);
        this.defaultReactGridParams.gridOptions.onSortChanged = (event) => this.initSelection(event.api);
        this.defaultReactGridParams.gridOptions.onFilterModified = (event) => this.initSelection(event.api);
    }

    isOnScreen(api, rowNode, identifier) {
        let isOnScreen = false;
        api.forEachNode(node => {
            if(node.data && node.data[identifier] == rowNode.data[identifier]) {
                isOnScreen = true;
            }
        });
        return isOnScreen;
    }

    filterChanged() {
        this.initSelection(this.gridApi);
        super.filterChanged();
    }

    initSelection(api, selectionList, identifier) {
        if (selectionList && !this.isAllSelected) {
            // only loops displayed nodes
            api.forEachNode(node => {
                if(node.data) {
                    node.setSelected(selectionList.includes(node.data[identifier]) ? true : false);
                }
            });
            api.redrawRows();
            this.updateSelectionLength(selectionList.length);
        } else if(this.isAllSelected) {
            api.forEachNode(node => node.setSelected(true));
            api.redrawRows();
            this.updateSelectionLength(api.paginationGetRowCount());
        }
    }

    updateSelection(row, selectionList, identifier) {
        this.$scope.parentController.$scope.detailForm.$setDirty();
        const nodeIndex = selectionList.indexOf(row.data[identifier]);
        if (row.node.isSelected()) {
            if (nodeIndex == -1) {
                selectionList.push(row.data[identifier]);
            }
        } else if(nodeIndex != -1 && this.isOnScreen(this.gridApi, row.node, identifier)){
            selectionList.splice(nodeIndex, 1);
        }
        this.updateSelectionLength(selectionList.length);
    }

    updateSelectionLength(length) {
        const tableParams = this.sessionPersistance.get(this.sessionPersistance.dataKey) || {};
        if(length) {
            tableParams.selectionLength = length;
        } else {
            delete tableParams.selectionLength;
        }
        this.sessionPersistance.set(this.sessionPersistance.dataKey, tableParams);
    }
}
